if(!window.dAgency) {
  window['dAgency'] = {}
}

// Helpers
var setCookie = function(cname, cvalue, options) {
  var d = new Date();
  d.setTime(d.getTime() + (options.expires * 24 * 60 * 60 * 1000));
  var expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path="+options.path+";domain="+options.domain;
}

var getCookie = function(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

var __GET = function(url, cb, json){
  var Http = new XMLHttpRequest();
  Http.open("GET", url);
  Http.send();

  if(cb) {
      Http.onreadystatechange = function() {
        if(Http.readyState === XMLHttpRequest.DONE && Http.status === 200) {
          cb.call(Http);
        }
      };
  }
}

var shallowInvertObject = function(object){
  var inverted = {};
  for (var prop in object) {
    if (object.hasOwnProperty(prop)) {
      var key = object[prop];
      inverted[key] = prop;
    }
  }

  return inverted;
}

var onDOMReady = function(callback){
  if (
      document.readyState === "complete" ||
      (document.readyState !== "loading" && !document.documentElement.doScroll)
  ) {
    callback();
  } else {
    document.addEventListener("DOMContentLoaded", callback);
  }
}

window.dAgency['Redirectify'] = function(options) {
  var errorStyling = "color:#000;font-family:system-ui;font-size:.8rem;background-color:#d6001c;padding:.3em;";
  var debugStyling = "color:#fff;font-family:system-ui;font-size:.8rem;background-color:#f012be;padding:.3em;";
  var redirectifyNoticeStyles = "color:#f012be;font-family:system-ui;font-size:2rem;font-weight:700;";

  // Do nothing if spiders
  if (/bot|google|baidu|bing|msn|duckduckbot|teoma|slurp|yandex|lighthouse/i.test(navigator.userAgent)) return;

  var defaults = {
    domain: 'dagency.it',
    instances: {
      'main': 'https://dagency.it',
      'eu': 'https://eu.dagency.it',
      'int': 'https://us.dagency.it',
      'de': 'https://de.dagency.it'
    },
    countries: {
      AU:'eu',
      BE: 'eu',
      DK: 'eu',
      FR: 'eu',
      DE: 'eu',
      LU: 'eu',
      NL: 'eu',
      IE: 'eu',
      AT: 'eu',
      SK: 'eu',
      ES: 'eu',
      CZ: 'eu',
      GR: 'eu',
      HU: 'eu',
      PL: 'eu',
      PT: 'eu',
      EE: 'eu',
      LV: 'eu',
      NO: 'eu',
      RO: 'eu',
      SE: 'eu',
      RU: 'eu',
      GB: 'eu',
      US: 'int'
    },
    auto: true, // False to use as API
    keepPath: true,
    cookie: {
      name: 'REDIRECTIFY',
      expiration: 365,
    },
    debug: false,
    switchers: '.redirectify-link'
  }

  var settings = options ? Object.assign(defaults, options) : defaults;
  // Create inverted instances object
  settings.instancesByHref = shallowInvertObject(settings.instances);

  /* if(_isSameReferrer(document.referrer)) return; */
  var currentDomain = window.location.protocol + '//' + window.location.hostname;
  var this_instance = _getInstanceByHref(currentDomain);

  // Get the URL from the instance name
  function _getUrl(instance) {
    return settings.instances[instance] || settings.instances['main'];
  }

  // Map country to instance
  function _getInstanceByCountry(iso) {
    return settings.countries[iso] || 'main';
  }

  // Extract the instance from the URL
  function _getInstanceByHref(href) {
    return settings.instancesByHref[href];
  }

  function _isSameReferrer(referrer) {
      if(!referrer) return;
      var isMappedInstance = false;

      for (var inst in settings.instances) {
        if (settings.instances.hasOwnProperty(inst)) {
          if(referrer.indexOf(settings.instances[inst]) >= 0) {
            isMappedInstance = true;
            break;
          }
        }
      }

      return isMappedInstance;
  }

  function _redirect(instance) {
      if(!instance) return; // Stop on invalid instance

      if (settings.debug) {
        return console.log('%cIP REDIRECT: redirect user from '+ _getUrl(this_instance) +' to ' + _getUrl(instance), debugStyling);
      } else {
        var redirectUrl = _getUrl(instance);
        redirectUrl = !settings.keepPath ? redirectUrl : redirectUrl + window.location.pathname;

        return window.parent.location.href = redirectUrl;
      }
  }

  function _setCookie(instance) {
    if (settings.debug) {
      console.log('%cSET COOKIE: "'+  settings.cookie.name +'" with value "' + instance +'"', debugStyling);
    }
      //console.log('set cookie instance: ' + instance);
      setCookie(settings.cookie.name, instance, { expires: settings.cookie.expiration, path: '/', domain: '.' + settings.domain });
  }

  function _geolocalize(cb){
    __GET('https://freegeoip.live/json/', cb);
  }

  function _isValidInstance(cookieValue){
    if (!settings.instances[cookieValue]) {
      console.trace('%cINVALID INSTANCE', errorStyling);
    }

    return settings.instances[cookieValue];
  }

  console.log('%cREDIRECTIFY', redirectifyNoticeStyles);


  onDOMReady(function(){

    // Register cookie based switchers
    if(settings.switchers && settings.cookie) {
      var switchers = Array.prototype.slice.call(document.querySelectorAll(settings.switchers));

      if(switchers.length) {
        switchers.map(function(switcher){
          switcher.addEventListener('click', function(e){
            e.preventDefault();
            e.stopPropagation();

            var url = this.getAttribute('href');
            var url_parts = url.split("/");
            var destination = url_parts[0] + '//' + url_parts[2];
            var destinationIntance = _getInstanceByHref(destination);

            if(destinationIntance) {
              _setCookie(destinationIntance);

              window.location.href = url;
            }
          });
        });
      }
    }
  });

  if(settings.auto){

    // COOKIE MODE!
    if(settings.cookie) {

      var cachedInstance = getCookie(settings.cookie.name);

      if (cachedInstance && _isValidInstance(cachedInstance)) { // If valid instance in cookie, use that.

          if(cachedInstance != this_instance){ // Unless current instance is different
           return _redirect(cachedInstance);
          }

          return;
      } else { //If no country in cookie, use geoloc
          _geolocalize(function() {
              if(!this.responseText) return;

              var data = JSON.parse(this.responseText);
              var instance = _getInstanceByCountry(data.country_code);

              if (_isValidInstance(instance)) {
                _setCookie(instance);

                if (instance != this_instance) {
                  return _redirect(instance);
                }
              }
          });
      }
    } else { // STRICT MODE! No cookie involved, always redirecting
      _geolocalize(function() {
          if(!this.responseText) return;

          var data = JSON.parse(this.responseText);
          var instance = _getInstanceByCountry(data.country_code);
          if (instance != this_instance) {
            return _redirect(instance);
          }
      });
    }
  }

  // Public API
  return {
    geolocalize: _geolocalize,
  }
};